import { Component, inject } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';

@Component({
  selector: 'app-about-us',
  templateUrl: './faq.html',
  imports: [
    MatTabGroup,
    MatTab,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    RouterLink
  ],
  styleUrl: './faq.scss'
})
export class Faq {
  userStore = inject(UsersStore);

}
